export default __webpack_public_path__ + "static/media/image-1.7856b1d8.jpg";